module.exports = __webpack_public_path__ + "static/media/sdk_enabled.7f1893c1.svg";